var sentenceCase = require('sentence-case')

/**
 * Dot case a string.
 *
 * @param  {String} string
 * @param  {String} [locale]
 * @return {String}
 */
module.exports = function (string, locale) {
  return sentenceCase(string, locale, '.')
}



//////////////////
// WEBPACK FOOTER
// ./~/dot-case/dot-case.js
// module id = 2437
// module chunks = 1